export default "__VITE_ASSET__b89b1dd1__"